import { jsx as n } from "react/jsx-runtime";
import { cx as i } from "../apps/ui/styled-system/css/cx.js";
import { css as s } from "../apps/ui/styled-system/css/css.js";
function u({
  children: o,
  className: t,
  type: r = "button",
  ...e
}) {
  return /* @__PURE__ */ n(
    "button",
    {
      className: i(
        s({
          _active: {
            transform: "translateY(1px)"
          },
          _disabled: {
            pointerEvents: "none"
          },
          _focusVisible: {
            outline: "2px solid var(--color-th_focus)"
          },
          cursor: "pointer!",
          display: "inline-flex",
          flex: "0 0 auto",
          outlineOffset: 2
        }),
        t
      ),
      type: r,
      ...e,
      children: o
    }
  );
}
export {
  u as ButtonArea
};
//# sourceMappingURL=ButtonArea.js.map
